const { LUMA, random, toHex, toRGB } = require('./helper');

/**
 * bright value 0 ~ 255
 * @param {number} min
 * @param {number} max
 * @returns {string} #000000
 */
const getRandomColor = (min = 0, max = 255) => {
  if (min < 0 || min > 255) min = 0;
  if (max < 0 || max > 255) max = 255;
  const [r, g, b] = [random(), random(), random()];
  const bright = [r, g, b].reduce((a, c, i) => a + c * LUMA[i], 0);
  return min <= bright && bright <= max
    ? `#${toHex(r)}${toHex(g)}${toHex(b)}`
    : getRandomColor(min, max);
};

const _moreBrightColor = (target, bright = 60) => {
  const [r, g, b] = target.map((value, index) => {
    let brightValue = Math.floor(value + bright * LUMA[index]);
    if (value == brightValue) brightValue += Math.floor(bright / 3) || 1;
    return Math.min(255, brightValue);
  });
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
/**
 *
 * @param {number} count colors count
 * @param {string} targetColor '#000000', default randomColor
 * @returns {string[]} ['#000000','#000000',.....]
 */
const getGradationColors = (
  count = 1,
  targetColor = getRandomColor(10, 180),
) => {
  const colors = [targetColor];
  while (colors.length < count) {
    colors[colors.length] = _moreBrightColor(
      toRGB(colors[colors.length - 1]),
      Math.floor(200 / count) || 1,
    );
  }
  return colors;
};

module.exports = {
  getGradationColors,
  getRandomColor,
};
